import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SignupPromptService } from '../../../core/services/signup-prompt.service';

@Component({
  selector: 'app-signup-prompt-modal',
  standalone: true,
  templateUrl: './signup-prompt-modal.component.html',
})
export class SignupPromptModalComponent {
  readonly promptService = inject(SignupPromptService);
  private readonly router = inject(Router);

  goToSignup(): void {
    this.promptService.hide();
    this.router.navigate(['/signup']);
  }

  goToLogin(): void {
    this.promptService.hide();
    this.router.navigate(['/login']);
  }
}
